import { StarbaseEntity } from 'starbase-launcher';
import { Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';
import { onlyUniqueByKey } from 'starbase-launcher';
import { environment } from '../../environments/environment';

/**  Maps the UID for each ImageType to the appropriate number for this instance of the app, as defined in environment files. */
export enum ImageTypes {
  'Photos' = environment.typeOfImageIds.Photos,
  'Ordnance_Returns' = environment.typeOfImageIds.Ordnance_Returns,
  'Letters & Diaries' = environment.typeOfImageIds['Letters & Diaries'],
  'Unspecified' = environment.typeOfImageIds.Unspecified,
  'Quartermaster_Report_of_Animals' = environment.typeOfImageIds['Quartermaster_Report_of_Animals'],
  'Morning_Reports' = environment.typeOfImageIds.Morning_Reports,
  'General_Special_Orders' = environment.typeOfImageIds['General_Special_Orders'],
  'Payroll_Documents' = environment.typeOfImageIds.Payroll_Documents,
  'Muster_Rolls' = environment.typeOfImageIds.Muster_Rolls,
  'Contracts' = environment.typeOfImageIds.Contracts,
  'Quartermaster_Manuals' = environment.typeOfImageIds.Quartermaster_Manuals,
  'No._33:_Requisition_for_Forage' = environment.typeOfImageIds['No._33:_Requisition_for_Forage'],
  'No. 2(b): Invoice of Ordnance and Ordnance Stores' = environment.typeOfImageIds['No. 2(b): Invoice of Ordnance and Ordnance Stores'],
  'No. 52: Receipt Roll for Clothing' = environment.typeOfImageIds['No. 52: Receipt Roll for Clothing'],
  'No. 3(a): For Issues of Ordnance Stores' = environment.typeOfImageIds['No. 3(a): For Issues of Ordnance Stores'],
  'No. 36: Requisition Sheet' = environment.typeOfImageIds['No. 36: Requisition Sheet'],
  'No. 7(a): For issues or Transfers of Ordnance Stores' = environment.typeOfImageIds['No. 7(a): For issues or Transfers of Ordnance Stores'],
  'No. 27: List of Clothing, Camp, and Garrison Equipage' = environment.typeOfImageIds['No. 27: List of Clothing, Camp, and Garrison Equipage'],
  'No. 40: Special Requisitions' = environment.typeOfImageIds['No. 40: Special Requisitions'],
  'No. 6: Consolidated Provision Return' = environment.typeOfImageIds['No. 6: Consolidated Provision Return'],
  'No. 1: Abstract of issues to the Volunteers & Militia' = environment.typeOfImageIds['No. 1: Abstract of issues to the Volunteers & Militia'],
  'Report of State of Regiment*' = environment.typeOfImageIds['Report of State of Regiment*'],
  'Report of Sick and Wounded' = environment.typeOfImageIds['Report of Sick and Wounded'],
  'Articles Lost or Destroyed in the Public Service*' = environment.typeOfImageIds['Articles Lost or Destroyed in the Public Service*'],
  'Invoice of Subsistence Stores*' = environment.typeOfImageIds['Invoice of Subsistence Stores*'],
  'Ordnance Returns: Return of Ordnance Stores' = environment.typeOfImageIds['Ordnance Returns: Return of Ordnance Stores'],
  'Quartermaster Returns: Inventory & Inspection of Quartermaster Property' = environment.typeOfImageIds['Quartermaster Returns: Inventory & Inspection of Quartermaster Property'],
  'No. 51: Monthly Return of Clothing, Camp, and Garrison Equipage' = environment.typeOfImageIds['No. 51: Monthly Return of Clothing, Camp, and Garrison Equipage'],
  'No. 45: List of Stores Transferred to' = environment.typeOfImageIds['No. 45: List of Stores Transferred to'],
  'Clothing_Ledger/Books' = environment.typeOfImageIds['Clothing_Ledger/Books']
}

export class ImageType extends StarbaseEntity implements Serializable<ImageType> {
    public typeOfImage: string;
    public specialFormatting: any;
    public prePrintedFormType: boolean;
    public lastModifiedDateTime: Date;
    public lastModifiedUser: string;

    constructor(imageTypeName?: string) {
        super();
        if (imageTypeName) {
            if (imageTypeName in ImageTypes) {
                this.uid = ImageTypes[imageTypeName];
                this.typeOfImage = imageTypeName;
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static imageTypes = Object.keys(ImageTypes).filter(a =>
        !(parseInt(a, 10) >= 0)).map(k => ({ val: environment.typeOfImageIds[k], txt: k, selected: false }));

    public static ImageTypeColumnData(imageTypes: ImageType[]): IColumnModel[] {
        imageTypes = onlyUniqueByKey(imageTypes, 'uid');
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false, null, null, 16),
            new ColumnModel('Image Type', 'typeOfImage', 'typeOfImage', false, 'dropdown', false, true, 100, true, imageTypes, 'typeOfImage', 18.5),
            new ColumnModel('Last Modified', 'lastModifiedDateTime', 'lastModifiedDateTime', false, 'date', false, true, 100, true, null, null, 16),
            new ColumnModel('Last Modified By User', 'lastModifiedUser', 'lastModifiedUser', false, 'string', false, true, 100, true, null, null, 13.5),
            new ColumnModel('Special Formatting', 'specialFormatting', 'specialFormatting', false, 'checkbox', false, true, 100, true),
            new ColumnModel('Pre-printed form', 'prePrintedFormType', 'prePrintedFormType', false, 'checkbox', false, true, 100, true),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, false, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 20, true),
        ];
    }

    deserialize(input) {
        return Object.assign(new ImageType(), input);
    }
}
